module.exports = "//static.hsappstatic.net/LoginUI/static-1.16097/img/okta-logo.svg"